// Google integration settings. The OAuth *client ID* is public (it ships in the browser bundle);
// set it in Netlify env as REACT_APP_GOOGLE_CLIENT_ID. Never put a client secret or tokens here.
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const GOOGLE_SYNC_ENABLED = Boolean(GOOGLE_CLIENT_ID) && process.env.REACT_APP_GOOGLE_SYNC_ENABLED === 'true';
export const GOOGLE_SCOPES = {
  calendar: 'https://www.googleapis.com/auth/calendar.events',
  contacts: 'https://www.googleapis.com/auth/contacts',
};
